__webpack_require__.p = "/war/assets/";